import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M20 11a1 1 0 0 1 1 1v3.241c0 .805 0 1.47-.044 2.01-.046.563-.144 1.08-.392 1.565a4 4 0 0 1-1.748 1.748c-.485.248-1.002.346-1.564.392-.541.044-1.206.044-2.01.044H8.758c-.805 0-1.47 0-2.011-.044-.562-.046-1.078-.145-1.563-.392a4 4 0 0 1-1.748-1.748c-.248-.485-.347-1.002-.393-1.564C3 16.71 3 16.046 3 15.242V12a1 1 0 0 1 2 0v3.2c0 .857.001 1.439.038 1.889.036.438.1.663.18.82a2 2 0 0 0 .874.873c.156.08.38.145.82.18C7.361 19 7.942 19 8.8 19h6.4c.857 0 1.439 0 1.889-.037.438-.036.663-.101.82-.18a2 2 0 0 0 .873-.875c.08-.156.145-.38.18-.82.038-.45.038-1.032.038-1.888V12a1 1 0 0 1 1-1m-8.707-7.707a1 1 0 0 1 1.414 0l3 3a1 1 0 1 1-1.414 1.414L13 6.414V15a1 1 0 1 1-2 0V6.414L9.707 7.707a1 1 0 1 1-1.414-1.414z"
    }, null, -1)
  ])))
}
export default { render: render }